"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCanonicalUrl = buildCanonicalUrl;
exports.createCanonical = createCanonical;
const segments_1 = require("../segments.js");
function buildCanonicalUrl(path) {
    const NEXT_PUBLIC_CANONICAL_URL = process.env.NEXT_PUBLIC_CANONICAL_URL;
    if (!NEXT_PUBLIC_CANONICAL_URL) {
        throw new Error("Missing `NEXT_PUBLIC_CANONICAL_URL` environment variable");
    }
    const baseUrl = NEXT_PUBLIC_CANONICAL_URL.replace(/\/$/, "");
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    return `${baseUrl}${normalizedPath}`;
}
function createCanonical({ routes }) {
    function stripEmbed(segments) {
        const { embed: _embed, ...rest } = segments;
        return rest;
    }
    const canonical = {
        homepage: () => buildCanonicalUrl("/"),
        base: (segments) => buildCanonicalUrl((0, segments_1.createBaseSegment)(stripEmbed(segments))),
        introduction: (segments, locale) => buildCanonicalUrl(routes.introduction(stripEmbed(segments), locale)),
        guide: (segments, locale) => buildCanonicalUrl(routes.guide(stripEmbed(segments), locale)),
        question: (segments, questionNumber, locale) => buildCanonicalUrl(routes.question(stripEmbed(segments), questionNumber, locale)),
        review: (segments, locale) => buildCanonicalUrl(routes.review(stripEmbed(segments), locale)),
        result: (segments, locale) => buildCanonicalUrl(routes.result(stripEmbed(segments), locale)),
        publicResult: (segments, publicId, locale) => buildCanonicalUrl(routes.publicResult(stripEmbed(segments), publicId, locale)),
        comparison: (segments, locale) => buildCanonicalUrl(routes.comparison(stripEmbed(segments), locale)),
    };
    return { canonical };
}
